import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.md};
  border-radius: ${theme.shapes.borderRadius.md};
  background-color: ${theme.colors.neutral['100']};
  border: 1px solid ${theme.colors.neutral.clear};
  margin-top: ${theme.spacing.md};
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.lg};
`

export const Footer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
`

export const UploadContainer = styled.div`
  #upload-container {
    border: none;
    padding: 0;
    margin: 0;
    background: transparent;

    span {
      text-decoration: none;
      font-size: ${theme.typography.sizes['2xs']};
      font-weight: ${theme.typography.weight.lg};
    }
  }
`
